import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ZoomProvider } from "./context/ZoomContext";

import Home from "./pages/Home";
import Dossiers from "./pages/Dossiers";
import DossierDetail from "./pages/DossierDetail";
import MediaDetail from "./pages/MediaDetail";
import NewArrivals from "./pages/NewArrivals";
import Search from "./pages/Search";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <ZoomProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { fontFamily: "JetBrains Mono, monospace", borderRadius: 9999, border: "2px solid #ffffff", background: "#000000", color: "#ffffff" } }} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dossiers" element={<Dossiers />} />
            <Route path="/dossiers/:slug" element={<DossierDetail />} />
            <Route path="/media/:id" element={<MediaDetail />} />
            <Route path="/new" element={<NewArrivals />} />
            <Route path="/search" element={<Search />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ZoomProvider>
    </AuthProvider>
  );
}

export default App;
